import type { ComponentContentType } from '@sydle/ui-utils';
import type { FileFieldValue } from './Fields/FileField/FileFieldValue';
import type { Reference } from './Reference';

export interface ReturnData {
  qrCode?: string;
  secret?: string;
  backupCodes?: string[];
  componentContent?: { authorized: boolean; parsedComponent: ComponentContentType };
  [key: string]: unknown;
}

export interface UserData {
  code: string;
  name: string;
  login: string;
  accessToken: AccessToken;
  operationCode: string;
  operationToken: string;
  loggedWithCustomURL?: boolean;
  returnData?: ReturnData;
}

export interface LoginData {
  code: string;
  name: string;
  login: string;
  operationCode: string;
  operationToken: string;
  accessToken: AccessToken;
  loggedWithCustomURL?: boolean;
}
export interface AccessToken {
  token: string;
  payload: AccessTokenPayload;
}
export interface AccessTokenPayload {
  exp: number;
  iat: number;
  _orgId: string;
  sessionTimeout?: null;
  authenticationClass: string;
  organizationId: string;
  active: boolean;
  code: string;
  sessionId: string;
  name: string;
  login: string;
  userPreferences: Reference;
  authenticatorId: string;
  _class: Reference;
  photo: UserPhoto;
  audiency?: string[] | null;
  oiat: number;
  userExtraInfo?: null;
  appDynamicAuthToken: boolean;
}

export type UserPhoto = FileFieldValue;
